import { createContext, Dispatch, SetStateAction, useContext } from "react"

export interface AEMAllowedToolsContextValue {
	tools: string[]
	setTools: Dispatch<SetStateAction<string[]>>
	loaded: boolean
	setLoaded: (val: boolean) => void
}

const AEMAllowedToolsContext =
	createContext<AEMAllowedToolsContextValue | null>(null)

export const useAEMAllowedToolsContext = () => {
	const ctx = useContext(AEMAllowedToolsContext)
	if (!ctx) {
		throw new Error(
			"useAEMAllowedToolsContext must be used within AEMAllowedToolsProvider"
		)
	}
	return ctx
}

export default AEMAllowedToolsContext
